<template>
  <div class="online-content" style="height:calc(100% - 60px);">
    <div class="online-studyEvaluate online-subject">
      <!-- 图片选择 题目 -->
      <PictureSelection
        :anwsersAll="anwsersList[question.currentId]"
        v-if="currentQuestion.category_id==11"
        :currentQuestionList="currentQuestionList"
        :currentId="question.currentId"
      ></PictureSelection>
      <!-- 文字选择 题目 -->
      <wordSelection
        :anwsersAll="anwsersList[question.currentId]"
        v-if="currentQuestion.category_id==12"
        :currentQuestionList="currentQuestionList"
      ></wordSelection>
      <!-- 填空题 -->
      <FillBlank
        :anwsersAll="anwsersList[question.currentId]"
        v-if="currentQuestion.category_id==15 || currentQuestion.category_id==16"
        :currentQuestionList="currentQuestionList"
      ></FillBlank>
      <!-- 判断题 -->
      <Judge
        :anwsersAll="anwsersList[question.currentId]"
        v-if="currentQuestion.category_id==18"
        :currentQuestionList="currentQuestionList"
      ></Judge>
      <!-- 图片点击 题目 -->
      <ImgClick
        v-if="currentQuestion.category_id==19"
        :currentQuestionList="currentQuestionList"
        :anwsersAll="anwsersList[question.currentId]"
      ></ImgClick>
      <!-- 排序题 -->
      <Sort
        v-if="currentQuestion.category_id==13 || currentQuestion.category_id==14 || currentQuestion.category_id==21"
        :currentQuestionList="currentQuestionList"
        :anwsersAll="anwsersList[question.currentId]"
        :anwsersListAll="anwsersList"
        :currentId="question.currentId"
      ></Sort>
      <!-- 拖拽题 -->
      <DragType
        v-if="currentQuestion.category_id==20"
        :currentQuestionList="currentQuestionList"
        :anwsersAll="anwsersList[question.currentId]"
        :anwsersListAll="anwsersList"
        :currentId="question.currentId"
      ></DragType>
      <!-- 连线题 -->
      <Connection v-if="currentQuestion.category_id==17" :currentQuestionList="currentQuestionList"
      :anwsersAll="anwsersList[question.currentId]"
      :anwsersListAll="anwsersList"
      :currentId="question.currentId"></Connection>
      <!-- 阅读题 -->
      <!-- {{anwsersList}}  {{question.currentId}} -->
      <Read
        v-if="currentQuestion.category_id==22"
        :currentQuestionList="currentQuestionList"
        :anwsersAll="anwsersList[question.currentId]"
        :anwsersListAll="anwsersList"
        :currentId="question.currentId"
        :readListContent="readListContent"
      ></Read>
      <!-- <div> <img src="@/assets/images/errorCurOne.png" alt="" style="width:60px;height:60px;"> </div> -->
      <div class="subject-change">
        <!-- {{question.currentId}}==={{question.length}} -->
        <!-- <span
          class="prev btn"
          :class="question.currentId==0?'':'cur'"
          @click="prevQuetion"
        >{{$t('Evaluation.prev')}}</span> -->
        <span
          class="next btn cur cursor"
          v-html="question.currentId>=question.length-1 ?$t('Evaluation.submitQuestion'):$t('Evaluation.next')"
          @click="nextQuetion"
        >{{$t('Evaluation.next')}}</span>
         <span
          class="next btn cur cursor"
          @click="currentAnlay"
          style="margin-left:40px;"
        >{{$store.state.currentChild.class_genre == 'school'?$t('Evaluation.analysis'):$t('Evaluation.explain')}}</span>
         <span
          class="next btn cur cursor"
          @click="currentQestionRemove"
          style="margin-left:40px;"
          v-if="currentQuestion.is_right==1 && mySourceErroy==1"
        >{{$t('Evaluation.removeQuestion')}}</span>
      </div>
    </div>

    <!-- 退出作答题目 弹窗 -->
    <popTips
      :dialogVisable="closeItem"
      :popTipsCont="popTips_close"
      @handConfirm="closeItem=false"
      @handCancel="closeItem=false"
      @handleCloseTip="closeItem=false"
    ></popTips>
    <!-- 超时弹窗 弹窗 -->
    <popTips
      :dialogVisable="timeOutItem"
      :popTipsCont="popTips_timeOut"
      @handConfirm="timeOutItem=false"
      @handCancel="timeOutItem=false"
      @handleCloseTip="timeOutItem=false"
    ></popTips>
    <!-- 题目解析 弹窗 -->
    <div class="Poplayer-box subject-Poplayer-box" v-if="subject.dialogVisable">
      <div class="Poplayer PoplayerOne">
        <div class="close" @click="handleCloseSubject">
          <img src="@/assets/images/close.png" alt />
        </div>
        <h3>{{$store.state.currentChild.class_genre == 'school'?$t('Evaluation.questionTitle'):$t('Evaluation.myReport')}}</h3>
        <div  style="height: 450px; overflow-y: auto;">
          <div class="prop-content" v-html="currentQuestionList.question_analysis"></div>
          <div class="prop-content-img tc">
            <img :src="currentQuestionList.question_analysisimg" style="max-width:200px;" alt="">
          </div>
          <!-- <div class="oprate">
            <span class="confirm bg-base btn">确定</span>
          </div> -->
         </div>
      </div>
    </div>
    <!-- 移除错题 弹窗 -->
    <div class="Poplayer-box subject-Poplayer-box"  v-if="removeQestion.dialogVisable">
      <div class="Poplayer PoplayerOne" style="height: 300px;">
        <div class="close" @click="removeQestion.dialogVisable=false">
          <img src="@/assets/images/close.png" alt />
        </div>
        <h3>{{$t('Evaluation.remove')}}</h3>
        <div class="prop-content" style="margin-bottom: 40px;">
          <p class="mb10">{{$t('Evaluation.content1')}}</p>
          <p class="mb10">{{$t('Evaluation.content2')}}</p>
          <p class="mb10">{{$t('Evaluation.content3')}}</p>
        </div>
        <div style="display:flex;justify-content: center;">
          <div class="oprate" style="position:static; margin-right:20px;">
            <span class="confirm bg-base btn cursor" @click="removeQestion.dialogVisable=false">{{$t('Common.cancle')}}</span>
          </div>
          <div class="oprate"  style="position:static">
            <span class="confirm bg-base btn cursor" @click="removeConfirm">{{$t('Evaluation.RemoveConfirm')}}</span>
          </div>
        </div>
      </div>
    </div>
    <message :message="message" :showTip="showTip" @hideTip="hideTip" />
  </div>
</template>

<script>
import evaluationStore from "@/views/StudyCenter/Evaluation/Evaluation";
import PictureSelection from "@/components/TestAnaly/PictureSelection";
import wordSelection from "@/components/TestAnaly/wordSelection";
import FillBlank from "@/components/TestAnaly/FillBlank";
import Judge from "@/components/TestAnaly/Judge";
import ImgClick from "@/components/TestAnaly/ImgClick";
import Sort from "@/components/TestAnaly/Sort";
import DragType from "@/components/TestAnaly/DragType";
import Connection from "@/components/TestAnaly/Connection";
import Read from "@/components/TestAnaly/Read";
import popTips from "@/components/popTips";
import message from "@/components/Common/message";
export default {
  name: "wrongAnalysis",
  components: {
    PictureSelection, //图片选择题
    wordSelection, //文字选选择题目
    FillBlank, //填空题
    Judge, //判断题
    ImgClick, //图片 点击题
    Sort, //排序题
    DragType, //拖拽题
    Connection, //连线题
    Read, //阅读题
    popTips,
    message
  },
  data() {
    return {
      message: "",
      showTip: false,
      mySourceErroy:0,//是否显示消除错题
      studentInfo: {
        token: "",
        member_id: "",
        student_id: "", //学生ID
        examine_branch: "", //检测编号
        examine_name: "", //检测名称
        classcode_branch: "", //班别编号
        examAgain: 0 //是考试记录里的 试题分析还是题目刚做完的 错题分析
      },
      question: {
        currentId: 0, //当前第几题
        length: "" //题目长度
      },
      questionsIdList: [],
      currentId: 1,
      closeItem: false, //删除孩子
      // 删除孩子 - 提示弹窗
      popTips_close: {
        // btn_text1: "确定删除",
        // btn_text2: "我在想想",
        title: this.$t('Common.tips'),
        context: this.$t('Common.invalid'),
        btns: [
          {
            text: this.$t('Common.confirmDelete'),
            event: "handConfirm"
          },
          {
            text: this.$t('Common.think'),
            event: "handCancel"
          }
        ]
      },
      timeOutItem: false, //超时弹窗
      // 超时弹窗 - 提示弹窗
      popTips_timeOut: {
        title: this.$t('Common.tips'),
        context: this.$t('Common.timeOut'),
        btns: [
          {
            text: this.$t('Common.confirm'),
            event: "handConfirm"
          }
        ]
      },
      allQuestionList: [],
      currentQuestion: {}, //当前题型 - 信息
      currentQuestionList: {}, //当前题目信息 - 传递到子组件
      anwsersList: [], //当前题目答案
      submitArr: [], //当前题目答案 - 替代
      allTime: "", //后台给的总时间
      timer_cout: "", //定时器
      remainTime: "", //考试剩余时间
      isClickNext: true, //是否可以点击下一题
      readQuestionIds: [], //阅读题 - 包含的题目数量
      readListContentAll: {
        //
      },
      readListContent: [],
      isClickPrev: true, //点击下一步
      //题目解析弹窗
      subject: {
        dialogVisable: false,
        context:""
      },
      //移除错题 弹窗
      removeQestion: {
        dialogVisable: false,
      },
    };
  },
  mounted() {
    if (window.history && window.history.pushState) {
      // 向历史记录中插入了当前页
      history.pushState(null, null, document.URL);
      window.addEventListener("popstate", this.goBack, false);
    }
    // window.addEventListener("beforeunload", e => this.beforeunloadFn(e));
  },
  updated() {},
  created() {
    this.studentInfo.token = this.$store.state.token;
    this.studentInfo.member_id = this.$store.state.member_id;
    this.studentInfo.student_id = this.$store.state.currentChild.student_id;
    this.studentInfo.examine_name = unescape(this.$route.query.examine_name);
    this.studentInfo.examine_branch = this.$route.query.examine_branch; //检测编号
    this.studentInfo.classcode_branch = this.$route.query.classcode_branch; //班别编号
    // this.getSubjects();

    //------存储头部信息 开始------
    this.$Tool.setStorage("InfoNameQuestion1", this.studentInfo.examine_name);
    this.$store.dispatch("setInfoNameQuestion1", this.studentInfo.examine_name);

    //------存储头部信息 结束------

    //是所有题目的分析 还是当前试卷的 错题分析
    this.studentInfo.examAgain = this.$route.query.examAgain
      ? this.$route.query.examAgain
      : 0;
    this.getHistoryAnswers();
    this.mySourceErroy = this.$route.query.mySourceErroy?this.$route.query.mySourceErroy:0;////是否显示消除错题
  },
  watch: {},
  computed: {},
  methods: {
    hideTip() {
      this.showTip = false;
    },
    //刷新页面
    // beforeunloadFn(e) {
    //   console.log("刷新页面");
    //   this.closeItem = true;
    // },
    //上一题
    prevQuetion() {
      this.question.currentId--;
      this.isClickPrev = false;
      if (this.question.currentId < 0) {
        this.question.currentId = 0;
        //------存储头部信息 开始------
        let idIndex = this.question.currentId;
        this.$Tool.setStorage("InfocurrentQuestion1", idIndex + 1);
        this.$store.dispatch("setInfocurrentQuestion1", idIndex + 1);
        //------存储头部信息 结束------
      } else {
        let index = this.question.currentId;
        this.currentQuestion = this.allQuestionList[index];
        //------存储头部信息 开始------
        let idIndex = this.question.currentId;
        this.$Tool.setStorage("InfocurrentQuestion1", idIndex + 1);
        this.$store.dispatch("setInfocurrentQuestion1", idIndex + 1);
        //------存储头部信息 结束------
        let currentId = this.currentQuestion.question_id;
        this.getQuestion(currentId);
        // this.getSubjects();
        console.log(this.anwsersList, "返回上一题时候此时的答案结构");
      }
    },
    //下一题
    nextQuetion() {
      this.isClickPrev = true;
      if (this.question.currentId >= this.question.length) {
        this.question.currentId = this.question.length - 1;
        //------存储头部信息 开始------
        let idIndex = this.question.currentId;
        this.$Tool.setStorage("InfocurrentQuestion1", idIndex + 1);
        this.$store.dispatch("setInfocurrentQuestion1", idIndex + 1);
        //------存储头部信息 结束------
      } else {
        this.question.currentId++;
        let index = this.question.currentId;
        console.log(index, "当前第几题题");
        //------存储头部信息 开始------
        let idIndex = this.question.currentId;
        this.$Tool.setStorage("InfocurrentQuestion1", idIndex + 1);
        this.$store.dispatch("setInfocurrentQuestion1", idIndex + 1);
        //------ 存储头部信息 结束------
        if (this.question.currentId >= this.question.length) {
          this.currentQuestion.category_id = "";
          // this.$router.go(-1);
          this.$router.push({
            path: "/studyEvaluate/answerResult",
            query: {
              examine_branch: this.studentInfo.examine_branch,
              examine_name: escape(this.studentInfo.examine_name),
              isSource:0,
            }
          });
        } else {
          this.currentQuestion = this.allQuestionList[index];
          let currentId = this.currentQuestion.question_id;
          this.getQuestion(currentId);
        }
      }
      console.log(this.currentQuestion.question_id)
    },
    //题目解析 弹窗 - 关闭
    handleCloseSubject() {
      this.subject.dialogVisable = false;
    },
    //获取 学生考试的答案
    getHistoryAnswers() {
      this.$store.dispatch("setLoadingStatus", true);
      evaluationStore
        .getHistoryAnswers({
          token: this.studentInfo.token, //登陆获取token
          member_id: this.studentInfo.member_id, //登陆获取的会员表
          student_id: this.studentInfo.student_id,
          examine_branch: this.studentInfo.examine_branch, //检测编号
          // is_wrong: this.studentInfo.examAgain//1 只获取错误数据
          is_wrong: 0//1 只获取错误数据
        })
        .then(res => {
          if (res.data.error == 0) {
            let list = res.data.result.list;
            this.allQuestionList = list;
            this.question.length = list.length;

            //------存储头部信息 开始------
            let idIndex = this.question.currentId;
            this.$Tool.setStorage("InfocurrentQuestion1", idIndex + 1);
            this.$store.dispatch("setInfocurrentQuestion1", idIndex + 1);
            this.$Tool.setStorage("InfoAllQuestion1", this.question.length);
            this.$store.dispatch("setInfoAllQuestion1", this.question.length);
            //------存储头部信息 结束------

            this.currentQuestion = list[0];
            let currentId = this.currentQuestion.question_id;
            this.getQuestion(currentId); //获取题目详情
          }
          this.$store.dispatch("setLoadingStatus", false);
         
        });
    },
    //获取 测评 题目问题详情
    getQuestion(id) {
      evaluationStore
        .getQuestion({
          token: this.studentInfo.token, //登陆获取token
          member_id: this.studentInfo.member_id, //登陆获取的会员表
          student_id: this.studentInfo.student_id,
          question_id: id,
          // question_id: this.currentQuestion.question_id,
          is_analysis: 1 //	是否需要题目分析 1-需要 不传为不需要
        })
        .then(res => {
          if (res.data.error == 0) {
            this.currentQuestionList = res.data.result.list;
            let type = res.data.result.list.category_id;
            let _this = this;
            //图片选择 -单选
            console.log(_this.anwsersList, "所以");
            console.log(_this.anwsersList.length);
            //阅读题
            console.log(this.allQuestionList);
            if (_this.anwsersList.length == 0) {
              this.allQuestionList.forEach(function(element) {
                let type1 = parseInt(element.category_id);
                console.log(type1);
                //图片选择 -单选
                let radioObj = {
                  question_id: element.question_id,
                  answers: element.answers,
                  category_id: element.category_id
                };
                console.log(type1, element.answers);
                let imgClickObj = {};
                if (
                  type1 == 16 ||
                  type1 == 19 ||
                  type1 == 13 ||
                  type1 == 14 ||
                  type1 == 21
                ) {
                  let eleArr = element.answers.split("|"); //字符分割
                  console.log(eleArr);
                  imgClickObj = {
                    question_id: element.question_id,
                    answers: eleArr,
                    category_id: element.category_id
                  };
                }

                var readClickObj = {
                  question_id: "",
                  answers: element.sonList,
                  category_id: ""
                };
                if (type1 == 11 || type1 == 15) {
                  _this.anwsersList.push(radioObj);
                } else if (
                  type1 == 16 ||
                  type1 == 19 ||
                  type1 == 13 ||
                  type1 == 14 ||
                  type1 == 21
                ) {
                  _this.anwsersList.push(imgClickObj);
                } else if (type1 == 22) {
                  readClickObj.question_id = element.question_id;
                  readClickObj.category_id = element.category_id;
                  console.log(readClickObj);
                  _this.anwsersList.push(readClickObj);
                } else {
                  _this.anwsersList.push(radioObj);
                }
              });
              console.log(_this.anwsersList, _this.anwsersList.length);
            }

            // console.log(readClickObj.answers,'此时的')
            if (type == 22) {
              let list = res.data.result.list;
              console.log(list);
              let idsArr = res.data.result.list.ids;
              this.questionsIdList = [];

              _this.readListContentAll = list;

              _this.readListContent = [];
              idsArr.forEach((item, index) => {
                console.log(
                  _this.anwsersList[_this.question.currentId].answers,
                  "当前-----"
                );

                // if(_this.isClickPrev){
                //   if(_this.anwsersList[_this.question.currentId].answers.length < idsArr.length){
                //     _this.anwsersList[_this.question.currentId].answers.push(obj);
                //   }
                // }
                this.questionsIdList.push(item.question_id);
                // _this.anwsersList.push(readClickObj);
              });

              _this.getQuestion1(this.questionsIdList);

              // let filterArr =  _this.anwsersList[_this.question.currentId].answers;
              // let arr2= filterArr.filter(function (item) {
              //   console.log(item.answers)
              //     return item.answers !='' && item.question_id;
              // });
              // console.log(readClickObj);
            }
            console.log(_this.anwsersList, _this.anwsersList.length);
            console.log(this.currentQuestionList, "问题详情");
          }
        });
    },
    //获取 测评 题目问题详情----阅读题--接口
    getQuestion1(ids) {
      let id = ids[0];
      let other = [];

      if (ids.length > 1) {
        other = ids.slice(1, ids.length);
      }

      evaluationStore
        .getQuestion({
          token: this.studentInfo.token, //登陆获取token
          member_id: this.studentInfo.member_id, //登陆获取的会员表
          student_id: this.studentInfo.student_id,
          question_id: id,
          // question_id: this.currentQuestion.question_id,
          is_analysis: 1 //	是否需要题目分析 1-需要 不传为不需要
        })
        .then(res => {
          if (res.data.error == 0) {
            let list = res.data.result.list;
            console.log(list);
            // this.readListContentAll.readListContent.push(list);
            this.readListContent.push(list);
            this.currentQuestionList = this.readListContentAll;
            console.log(this.readListContentAll, "所有的题目详情");
            console.log(this.currentQuestionList, "问题详情");
          }
          if (ids.length > 1) {
            this.getQuestion1(other);
          }
        });
    },
    //点击 题目分析
    currentAnlay(){
      this.subject.dialogVisable = true;
    },
    //检测->消除错题 -接口
    getRemoveWrongQuestion() {
      evaluationStore
        .getRemoveWrongQuestion({
          token: this.studentInfo.token, //登陆获取token
          member_id: this.studentInfo.member_id, //登陆获取的会员表
          student_id: this.studentInfo.student_id,
          question_id:this.currentQuestion.question_id,
        })
        .then(res => {
          if (res.data.error == 0) {
            this.removeQestion.dialogVisable = !this.removeQestion.dialogVisable;
            // this.getHistoryAnswers();
             //------存储头部信息 开始------
            // this.question.currentId =0;
            // let idIndex = this.question.currentId;
            // this.$Tool.setStorage("InfocurrentQuestion1", idIndex + 1);
            // this.$store.dispatch("setInfocurrentQuestion1", idIndex + 1);
            // this.$Tool.setStorage("InfoAllQuestion1", this.question.length);
            // this.$store.dispatch("setInfoAllQuestion1", this.question.length);
            //------存储头部信息 结束------
          } 
          this.message = res.data.errortip;
          this.showTip = true;  
        });
    },
    //消除错题 - 点击显示
    currentQestionRemove(){
      this.removeQestion.dialogVisable = !this.removeQestion.dialogVisable;
    },
    //消除错题 - 点击提交
    removeConfirm(){
      this.getRemoveWrongQuestion();
    },
    // 点击了浏览器的返回上一页
    goBack() {
     this.$router.push({
       path: '/studyEvaluate/evaluationList'
     })
      console.log(document.URL);
      // console.log("点击了浏览器的返回按钮");
      // history.pushState(null, null, document.URL);
    },
  },
  destroyed() {
    window.removeEventListener("popstate", this.goBack, false);
    // window.removeEventListener("beforeunload", e => this.beforeunloadFn(e));
  }
};
</script>

<style lang="less">
// @import '../study-center1.styl';
.subject-Poplayer-box .Poplayer {
  width: 50%;
  height: 520px;
}
.subject-Poplayer-box .Poplayer .oprate {
  position: absolute;
  bottom: 20px;
  left: 50%;
  transform: translateX(-50%);
}
.subject-Poplayer-box .Poplayer .prop-content {
  padding: 26px;
  text-align: left;
}
</style>
